import { defineStore } from 'pinia'

import { createProductTemplatesActions } from './actions'
import { createProductTemplatesState } from './state'

export const useProductTemplatesStore = defineStore('productTemplates', () => {
    const state = createProductTemplatesState()
    const actions = createProductTemplatesActions(state)

    return {
        ...state,
        ...actions
    }
})
